import { RegisterOptions } from 'react-hook-form';

import { ErrorType, RegisterType } from 'types';

import { Label } from 'components/Label';

import * as S from './TextArea.styles';
import { StyledAreaProps } from './TextArea.styles';

type TextAreaProps = {
  value?: string | number;
  name: string;
  options?: RegisterOptions;
  error?: ErrorType;
  label?: string;
  register: RegisterType;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  maxLength?: number;
  onKeyDown?: (e: KeyboardEvent) => void;
  onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
} & StyledAreaProps;

const defaultProps: Partial<TextAreaProps> = {
  value: undefined,
  placeholder: undefined,
  disabled: false,
  options: {},
  error: undefined,
  required: false,
  height: undefined,
  register: undefined,
  className: undefined,
  maxLength: undefined,
  onKeyDown: undefined,
  onBlur: undefined,
  onChange: undefined,
};

export function TextArea(props: TextAreaProps): React.ReactElement {
  const {
    value,
    name,
    label,
    register,
    placeholder,
    disabled,
    options,
    error,
    required,
    height,
    className,
    maxLength,
    onKeyDown,
    onBlur,
    onChange,
  } = {
    ...defaultProps,
    ...props,
  };

  const registered = register(name, options);

  return (
    <S.Container className={className}>
      {label && (
        <Label htmlFor={name} required={required} error={error}>
          {label}
        </Label>
      )}

      <S.Area
        disabled={disabled}
        {...registered}
        placeholder={placeholder}
        defaultValue={value}
        required={required}
        height={height}
        maxLength={maxLength}
        onKeyDown={(e: unknown) => onKeyDown && onKeyDown(e as KeyboardEvent)}
        onBlur={(e: React.FocusEvent<HTMLTextAreaElement>) => {
          registered.onBlur(e);
          if (onBlur) onBlur(e as unknown as React.ChangeEvent<HTMLInputElement>);
        }}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
          registered.onChange(e);
          if (onChange) onChange(e);
        }}
      />
    </S.Container>
  );
}
